<div class="checkout-billing-address border mb-4">
  <div class="border-bottom">
    <h5 class="m-0 p-3">
      <span><fa-icon [icon]="['fas', 'file']" /></span>
      {{ 'checkout.address.billing.label' | translate }}
    </h5>
  </div>
  <div class="p-3">
    @if (invoiceAddress$ | async; as address) {
    <div class="address-box">
      <!-- edit invoice address -->
      <div class="invoice-icon">
        @if (collapseChange | async) {
        <a
          class="btn-tool float-right"
          [title]="'checkout.address.update.title' | translate : { '0': 'checkout.address.billing.label' | translate }"
          (click)="showAddressForm(address)"
          data-testing-id="edit-invoice-address-link"
        >
          <fa-icon [icon]="['fas', 'pencil-alt']" />
        </a>
        }
      </div>
      <!-- display invoice address -->
      <ish-address [address]="address" [displayEmail]="true" />
    </div>
    @if (!address && showErrors()) {
    <p class="text-danger">
      {{ 'checkout.addresses.no_Selection.invoice.error' | translate }}
    </p>
    } }
  </div>
  <div class="invoice-address p-3">
    <!-- invoice address selection -->
    @if (addresses$ | async; as addresses) { @if (addresses.length) {
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" />
    </form>
    } }

    <!-- Add a new Invoice to address -->
    @if ((collapseChange | async) && (isLoggedIn$ | async)) {
    <div class="row">
      <button
        data-testing-id="create-invoice-address-link"
        class="btn btn-link"
        (click)="showAddressForm()"
        [attr.aria-expanded]="(collapseChange | async) === false"
        aria-controls="invoice-address-panel"
      >
        {{ 'checkout.create_invoice_address.link' | translate }}
      </button>
    </div>
    }

    <!-- invoice address form -->
    <div id="invoice-address-panel" [ngbCollapse]="collapseChange | async" data-testing-id="invoice-address-form">
      <ish-formly-customer-address-form
        [address]="editAddress"
        [resetForm]="collapseChange | async"
        [extension]="(isLoggedIn$ | async) === false"
        (save)="saveAddress($event)"
        (cancel)="cancelEditAddress()"
      />
    </div>
  </div>
</div>

@if ((collapseChange | async) === false) {
<ish-lazy-address-doctor />
}
